import { render, staticRenderFns } from "./TenderingList.vue?vue&type=template&id=0020f664&scoped=true"
import script from "./TenderingList.vue?vue&type=script&lang=js"
export * from "./TenderingList.vue?vue&type=script&lang=js"
import style0 from "./TenderingList.vue?vue&type=style&index=0&id=0020f664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020f664",
  null
  
)

export default component.exports